import { Controller } from '@hotwired/stimulus';

var Highcharts = require('highcharts');
// Load module after Highcharts is loaded
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/accessibility')(Highcharts);

export default class extends Controller {
  static targets = ['dayButton', 'weekButton'];
  static values = {
    condition: Number,
    dayData: Array,
    weekData: Object,
    date: String,
    intensityHigh: Number,
    intensityLow: Number,
    startTime: Number,
    endTime: Number,
    locale: String,
    daysTranslation: Array,
    timeTranslation: String,
    intensityCountsTranslation: String,
    intensityLowTranslation: String,
    intensityValuesTranslation: String,
    intensityHighTranslation: String,
    dateTranslation: String,
    minutesTranslation: String,
    highTranslation: String,
    mediumTranslation: String,
    lowTranslation: String,
    viewFullscreenTranslation: String,
    printChartTranslation: String,
    downloadPngImageTranslation: String,
    downloadJpgImageTranslation: String,
    downloadPdfTranslation: String,
    downloadSvgTranslation: String
  };

  initialize() {
    Highcharts.setOptions({ locale: this.localeValue });
  }

  showDay() {
    this.weekButtonTarget.disabled = false;
    this.dayButtonTarget.disabled = true;
    this.showDayChart();
  }

  showWeek() {
    this.dayButtonTarget.disabled = false;
    this.weekButtonTarget.disabled = true;
    this.showWeekChart();
  }

  dayDataValueChanged() {
    this.showDayChart();
  }

  showDayChart() {
    let intensity = [];
    let ilow = [];
    let ihigh = [];
    let lowmin = 0;
    let highmin = 0;
    let medmin = 0;
    const pointWidth = 3;
    const color_low = '#DC1D0C';
    const color_high = '#01A008';

    this.dayDataValue.forEach((value) => {
      let item = [];
      let item_intensity = [];
      let intensity_low = [];
      let intensity_high = [];
      let datestr = new Date(value.time);
      let utc = Date.UTC(
        datestr.getFullYear(),
        datestr.getMonth(),
        datestr.getDate(),
        datestr.getHours(),
        datestr.getMinutes()
      );
      const datestr2 = new Date(this.dateValue + 'T00:00:00');
      var utc_start = Date.UTC(
        datestr2.getFullYear(),
        datestr2.getMonth(),
        datestr2.getDate(),
        0,
        0
      );
      const min_total = (utc - utc_start) / 60000;
      item.push(min_total, value.activity_counts);

      if (this.startTimeValue == 0) {
        item_intensity.push(utc, value.activity_counts);
        intensity.push(item_intensity);

        if (this.conditionValue > 0) {
          intensity_low.push(utc, parseInt(this.intensityLowValue));
          intensity_high.push(utc, parseInt(this.intensityHighValue));
          ilow.push(intensity_low);
          ihigh.push(intensity_high);
        }
      } else if (
        min_total > this.startTimeValue &&
        min_total < this.endTimeValue
      ) {
        item_intensity.push(utc, value.activity_counts);
        intensity.push(item_intensity);

        var min = value.activity_counts;

        if (this.conditionValue > 0) {
          intensity_low.push(utc, parseInt(this.intensityLowValue));
          intensity_high.push(utc, parseInt(this.intensityHighValue));

          ilow.push(intensity_low);
          ihigh.push(intensity_high);

          if (min >= parseInt(this.intensityHighValue)) {
            highmin++;
          } else if (
            min < parseInt(this.intensityHighValue) &&
            min > parseInt(this.intensityLowValue)
          ) {
            medmin++;
          } else if (min > 200 && min <= parseInt(this.intensityLowValue)) {
            lowmin++;
          }
        }
      }
    });

    this.settotalmin(0, 0, 0, '2');
    const chart = Highcharts.chart('totalExerciseChart', {
      chart: {
        type: 'column'
      },
      lang: {
        locale: this.localeValue,
        printChart: this.printChartTranslationValue,
        viewFullscreen: this.viewFullscreenTranslationValue,
        downloadPNG: this.downloadPngImageTranslationValue,
        downloadJPEG: this.downloadJpgImageTranslationValue,
        downloadPDF: this.downloadPdfTranslationValue,
        downloadSVG: this.downloadSvgTranslationValue
      },
      tooltip: {
        formatter: function () {
          return (
            '' +
            '' +
            this.timeTranslationValue +
            ': ' +
            Highcharts.dateFormat('%I:%M %p', this.x) +
            ' ' +
            this.series.name +
            ': ' +
            this.y
          );
        }
      },

      yAxis: {
        title: {
          text: this.intensityCountsTranslationValue,
          style: {
            fontSize: '16px'
          }
        },
        labels: {
          style: {
            fontSize: '13px'
          }
        }
      },

      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          millisecond: '%I %p',
          second: '%I %p',
          minute: '%I:%M%P',
          hour: '%I %p'
        },
        title: {
          text: this.timeTranslationValue,
          style: {
            fontSize: '16px'
          }
        },
        labels: {
          style: {
            fontSize: '13px'
          }
        }
      },

      series: [
        {
          type: 'spline',
          name: this.intensityLowTranslationValue,
          data: ilow,
          color: color_low,
          marker: {
            lineWidth: 2,
            lineColor: color_low,
            fillColor: 'white'
          }
        },

        {
          name: this.intensityValuesTranslationValue,
          data: intensity,
          color: '#D89DF1',
          pointWidth: pointWidth,
          visible: true
        },
        {
          type: 'spline',
          name: this.intensityHighTranslationValue,
          data: ihigh,
          color: color_high,
          marker: {
            lineWidth: 2,
            lineColor: color_high,
            fillColor: 'white'
          }
        }
      ],

      title: {
        text: ''
      },

      loading: false
    });
  }

  settotalmin(lowmin, highmin, medmin, condition) {
    if (parseInt(condition) == 2) {
      this.total_steps = highmin;
    } else if (parseInt(condition) == 1) {
      this.total_steps = lowmin;
    }

    var message = { low: lowmin, high: highmin, med: medmin };
  }

  showWeekChart() {
    const color_low = '#DC1D0C';
    const color_high = '#01A008';
    var days = this.daysTranslationValue;
    let dates = this.weekDataValue.dates;

    const chart = Highcharts.chart('totalExerciseChart', {
      chart: {
        type: 'column'
      },
      lang: {
        locale: this.localeValue,
        printChart: this.printChartTranslationValue,
        viewFullscreen: this.viewFullscreenTranslationValue,
        downloadPNG: this.downloadPngImageTranslationValue,
        downloadJPEG: this.downloadJpgImageTranslationValue,
        downloadPDF: this.downloadPdfTranslationValue,
        downloadSVG: this.downloadSvgTranslationValue
      },
      tooltip: {
        formatter: function () {
          var index = days.indexOf(this.x);
          return (
            '' +
            this.dateTranslationValue +
            ': ' +
            this.x +
            ' ' +
            this.series.name +
            ': ' +
            this.y
          );
        }
      },

      legend: {
        reversed: true
      },

      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
            color:
              (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white',
            style: {
              textShadow: '0 0 3px black'
            }
          }
        }
      },

      yAxis: {
        title: {
          text: this.minutesTranslationValue,
          style: {
            fontSize: '16px'
          }
        },
        labels: {
          style: {
            fontSize: '13px'
          }
        },
        stackLabels: {
          enabled: true,
          style: {
            fontWeight: 'bold',
            color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
          }
        }
      },

      xAxis: {
        categories: days,

        title: {
          text: this.dateTranslationValue,
          style: {
            fontSize: '16px'
          }
        },
        labels: {
          style: {
            fontSize: '13px'
          }
        }
      },

      series: [
        {
          name: this.highTranslationValue,
          color: color_high,
          data: this.weekDataValue.high_intensity
        },
        {
          name: this.mediumTranslationValue,
          color: '#ffc125',
          data: this.weekDataValue.medium_intensity
        },
        {
          name: this.lowTranslationValue,
          color: color_low,
          data: this.weekDataValue.low_intensity
        }
      ],

      title: {
        text: ''
      },

      loading: false
    });
  }
}
